/* Subject dropdown options for the Contact form */
export const SUBJECTS = [
    "Business Consulting",
    "Web Design & Development",
    "Technical Consulting",
    "Earth Healing",
    "Project Collaboration",
    "Other",
];
